export default {
  EMPTY: 'empty',
  HALF: 'half',
  FULL: 'full',
};
